/**
 * buildPeriodEndDates — Phase 6a.20i shared utility.
 *
 * Returns the list of valid period-end dates for a lease, derived as
 * `commencementDate + N months` for `N = 1..min(leaseTermMonths, 1200)`.
 * Empty array when either input is missing or malformed — callers
 * render a "fill the prerequisites first" placeholder instead of an
 * empty Select.
 *
 * Extracted from TerminationSection.tsx (Phase 6a.20c) so all three
 * period-end-bound date inputs share one source of truth:
 *   • TerminationSection.terminationDate
 *   • ModificationCard.modificationDate
 *   • IndexResetCard.resetDate
 */

import { addMonths, format, parseISO } from "date-fns";

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export function buildPeriodEndDates(
  commencementDate: string | undefined,
  leaseTermMonths: number | string | undefined,
): string[] {
  if (!commencementDate || !ISO_DATE_RE.test(commencementDate)) return [];
  const term = Number(leaseTermMonths);
  if (!Number.isFinite(term) || term < 1) return [];
  const base = parseISO(commencementDate);
  const list: string[] = [];
  for (let n = 1; n <= Math.min(term, 1200); n++) {
    list.push(format(addMonths(base, n), "yyyy-MM-dd"));
  }
  return list;
}
